import React from 'react';
import HomePage from "./pages/Home/HomePage";

function App() {
    return <HomePage />
}

export default App;
